import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="form-disable-submit"
export default class extends Controller<HTMLFormElement> {
  connect () {
    // Automatically attach the disableForm action to the form's submit event handler.
    this.element.dataset['action'] = 'submit->form-disable-submit#disableForm'
  }

  disableForm (_event: SubmitEvent) {
    this.submitElements().forEach(element => {
      if (element instanceof HTMLButtonElement) {
        element.disabled = true
      } else if (element instanceof HTMLInputElement) {
        element.disabled = true
      } else {
        console.warn('FormDisableSubmitController: submit element is not a button or input', element)
      }
    })
  }

  private submitElements () {
    return this.element.querySelectorAll("[type='submit']")
  }
}
